import React from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { color } from "@vds-tokens/core";
import { Text, Button } from "@vds/core";
import { UnorderedList, ListItem } from "@vds/lists";
// import { Button } from "@vds3/buttons";
// import { Body, Title, Micro } from "@vds3/typography";
import {
	MarginSpacerS,
	MarginSpacerL,
	MarginSpacerM,
	MarginSpacerXL,
} from "common/components/styleTag";
import { CollapsibleList } from "common/components";
import { formatPriceString } from "utils/commonUtils";
import BroadbandPlan from "common/components/FWA/PlanSelectionNew/BroadbandPlan";
import BroadbandFacts from "common/components/BroadbandFacts/BroadbandFacts";
import { htmlDecode } from "utils/commonUtils";

const BusinessPlanCard = ({
	planDetail,
	aemContent,
	autoPayDiscount,
	noOfLines,
	isEnabled,
	onSelect,
	tierPrices,
	aemFeatures,
	isRecommended,
	promoSpacing = false,
	maxEligibility,
	fromFeature = false,
	buttonTextOverride,
	useTierPrices,
	totalNumberOfLines,
	packages = null,
	newMixedCartContent = false,
	isLandingFromInternetWithMobile,
	isJOBundle,
	fromPlansNewCt,
	elegibleBillingCode,
	...props
}) => {
	const { t } = useTranslation(["plans"]);
	const {
		displayName,
		monthlyFee,
		planDiscountMonthlyFee,
		promoEligible,
		name,
		retailPrice,
	} = planDetail || {};
	const isPromoEligible = props?.isPromoEligible || promoEligible;
	const isMobile = useMediaQuery({
		query: "(max-width: 545px)",
	});

	const getPrice = () => {
		let finalPrice;
		if (totalNumberOfLines < 6) {
			const checkPrice = tierPrices && tierPrices[totalNumberOfLines];
			finalPrice =
				useTierPrices && totalNumberOfLines
					? Number(checkPrice) + Number(autoPayDiscount)
					: name && name
					? parseInt(retailPrice) == parseFloat(retailPrice)
						? retailPrice
						: Number(retailPrice)?.toFixed(2)
					: Number.parseInt(planDiscountMonthlyFee || monthlyFee);
		} else {
			finalPrice =
				useTierPrices && totalNumberOfLines
					? Number(tierPrices[5]) + Number(autoPayDiscount)
					: name && name
					? parseInt(retailPrice) == parseFloat(retailPrice)
						? retailPrice
						: Number(retailPrice)?.toFixed(2)
					: Number.parseInt(planDiscountMonthlyFee || monthlyFee);
		}
		return finalPrice;
	};

	const getFinalPrice = () => {
		let price = getPrice();
		if (autoPayDiscount) {
			const discount = Number.parseInt(autoPayDiscount);
			price -= discount;
		}
		return price;
	};

	return (
		<>
			<TileContainer
				height={props?.height}
				minHeight={props?.minHeight}
				fromFeature={fromFeature}
				isPromoEligible={isPromoEligible}
				promoSpacing={promoSpacing}
				noOfLines={props?.fromPlansNew ? props?.selected : noOfLines && noOfLines}
				totalNumberOfLines={packages ? Object.keys(packages)?.length : 1}
			>
				{!!isPromoEligible && (
					<PromoBadge>
						<Text kind="body" size="small" bold color="#FFFFFF">
							{t("plans.aggregate_plans.tradeInPromoMsg", { ns: "plans" })}
						</Text>
					</PromoBadge>
				)}
				<TileContents>
					{isRecommended ? (
						<>
							<Text kind="body" size="small" color="#EE0000">
								{t("plans.aggregate_plans.recommendedText", { ns: "plans" })}
							</Text>
							<MarginSpacerS />
						</>
					) : (
						<MarginSpacerL />
					)}
					<TopSection
						className="top-section"
						minHeight={props.minHeightTitle}
						height={props?.height}
					>
						<Text kind="title" size={isMobile ? "large" : "small"} color={color.element.brandhighlight.onlightprimary}>
							{htmlDecode(displayName ? displayName : name)}
						</Text>
						{name && (
							<Text kind="body" size="small">
								{
									planDetail.maxEligibility === null ? "Single device" : ""
									// planDetail.minEligibility +
									// "-" +
									// planDetail.maxEligibility +
									// " devices"
								}
							</Text>
						)}
					</TopSection>
					{!props?.selected && (
						<Button
							kind="secondary"
							size="large"
							width="100%"
							disabled={fromPlansNewCt ?
								((!elegibleBillingCode || elegibleBillingCode.length === 0)||(elegibleBillingCode && elegibleBillingCode.length && !elegibleBillingCode.includes(planDetail?.billingCode))) ? true : false
								: !isEnabled}
							onClick={() => {
								onSelect(planDetail.billingCode, planDetail);
							}}
							data-track={
								props?.fromPlansNew && !fromFeature && props?.selected
									? "Keep this plan"
									: props?.fromPlansNew && fromFeature && props?.selected
									? t("features.device-protection.keep_protection_plan", {
											ns: "features",
									  })
									: buttonTextOverride
									? buttonTextOverride
									: aemFeatures?.["buttonText"]
									? aemFeatures["buttonText"]
									: fromFeature
									? t("features.device-protection.add_protection_plan", {
											ns: "features",
									  })
									: t("plans.aggregate_plans.select_plan", { ns: "plans" })
							}
							style={{
								color:
									isJOBundle && buttonTextOverride == "Selected"
										? "rgb(0,119,180)"
										: "black",
							}}
						>
							{props?.fromPlansNew && !fromFeature && props?.selected
								? "Keep this plan"
								: props?.fromPlansNew && fromFeature && props?.selected
								? t("plans.keep_protection_plan", { ns: "plans" })
								: buttonTextOverride
								? buttonTextOverride
								: aemFeatures?.["buttonText"]
								? aemFeatures["buttonText"]
								: fromFeature
								? t("plans.add_protection_plan", { ns: "plans" })
								: t("plans.aggregate_plans.select_plan", { ns: "plans" })}
						</Button>
					)}
					{newMixedCartContent ? (
						<></>
					) : props?.fromPlansNew && props?.selected ? (
						<AppliedToLines>
							<Text kind="body" size="large" color="#0077B4" bold>
								{" "}
								{fromFeature ? "You added this protection" : "You selected this plan"}
								{/* <div style={{ marginBottom: "2.5rem" }} /> */}
							</Text>
						</AppliedToLines>
					) : noOfLines && !isLandingFromInternetWithMobile ? (
						<AppliedToLines>
							<Text kind="body" size="small" color="#0077B4" bold>
								{`Applied to ${noOfLines} ${noOfLines > 1 ? "lines" : "line"}`}
								{/* <div style={{ marginBottom: "2.5rem" }} /> */}
							</Text>
						</AppliedToLines>
					) : (
						// <div style={{ marginBottom: "2.5rem" }} />
						<></>
					)}
					<MarginSpacerM />
					<PriceLockup name={name}>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<Text kind="title" size="medium" bold primitive="h1">
								{`${formatPriceString(getFinalPrice(), true)}`}
							</Text>
							{!!planDiscountMonthlyFee && (
								<Text kind="body" size="small" strikethrough>
									{formatPriceString(monthlyFee)}
								</Text>
							)}
						</div>
						<div style={{ maxWidth: "166px" }}>
							<Text kind="body" bold={name ? true : false} size={name ? "large" : "small"}>
								{fromFeature
									? planDetail.maxEligibility === null
										? t("plans.aggregate_plans.perLine", { ns: "plans" })
										: t("plans.aggregate_plans.perMonth", { ns: "plans" })
									: t("plans.aggregate_plans.perLine", { ns: "plans" })}
							</Text>
							{!name && (
								<Text kind="body" size="small">
									{t("plans.aggregate_plans.plusTax", { ns: "plans" })}
								</Text>
							)}
						</div>
					</PriceLockup>
					{!!autoPayDiscount && (
						<div style={{ marginTop: "0.75rem", height: "3vh" }}>
							<Text kind="body" size="small">
								{`${formatPriceString(getPrice(), true)} ${t(
									"plans.buePlansCard.withoutAutoPay",
									{ ns: "plans" }
								)}`}
							</Text>
						</div>
					)}
					<MarginSpacerM />
					{!!tierPrices &&
						!newMixedCartContent &&
						!isLandingFromInternetWithMobile && (
							<>
								<PriceTierGrid>
									{Object.entries(tierPrices)?.map(([key, value]) => (
										<>
											<PriceTierPrice>{`${formatPriceString(
												value,
												true
											)}`}</PriceTierPrice>
											<PriceTierLines>{`${key}${key == 5 ? "+" : ""} ${t(
												"plans.buePlansCard.lines",
												{ count: Number(key), ns: "plans" }
											)}`}</PriceTierLines>
										</>
									))}
								</PriceTierGrid>
								<MarginSpacerM />
							</>
						)}
						{!!aemContent?.detailBullets?.length && (
							<BottomSection>
							<MarginSpacerM />
							<Text kind="body" size="small" bold>
								{aemContent?.detailHeading}
							</Text>
							<UnorderedList>
								{aemContent?.detailBullets?.map((i) => (
								<ListItem size="bodySmall" spacing="compact">
									<span
									dangerouslySetInnerHTML={{
										__html: i,
									}}
									/>
								</ListItem>
								))}
							</UnorderedList>
							</BottomSection>
						)}
					{/* {newMixedCartContent && <MarginSpacerL />}
          <ItemWrapper>
            {!!aemFeatures && (
              <CollapsibleList
                heading={aemFeatures?.heading}
                items={aemFeatures?.features || []}
                gap="0.75rem"
              />
            )}
            {!!aemFeatures && !!aemFeatures?.discountHeading && (
              <>
                <MarginSpacerL />
                <CollapsibleList
                  heading={aemFeatures?.discountHeading}
                  items={aemFeatures?.discountFeatures || []}
                  gap="0.75rem"
                />
              </>
            )}
            {!!aemFeatures?.disclaimers?.length && (
              <>
                <MarginSpacerL />
                {aemFeatures.disclaimers.map((item) => (
                  <DisclaimerItem key={item}>
                    <Micro>{item}</Micro>
                  </DisclaimerItem>
                ))}
              </>
            )}

          </ItemWrapper> */}
					<MarginSpacerS />
					{/* <BroadbandPlan planId={planDetail?.billingCode} flow="nse" /> */}
          <BroadbandFacts planId={planDetail?.billingCode} flow="nse" />
				</TileContents>
			</TileContainer>
		</>
	);
};

const TileContainer = styled.div`
	min-width: 290px;
	height: ${({ height }) => (height ? height : "auto")};
	min-height: ${({ isPromoEligible }) => (isPromoEligible ? "600px" : "auto")};
	flex-shrink: 0;
	border-radius: 8px;
	border: ${(props) =>
		props.noOfLines
			? `2px solid var(--vds-elements-text-icons-borders-lowcontrast-onlight, #000)`
			: `1px solid var(--vds-elements-text-icons-borders-lowcontrast-onlight, #d8dada)`};

	background: #fff;
	padding: 1rem 0 1.5rem 0;
	padding-top: ${(props) => (props?.isPromoEligible ? "0" : "1rem")};
	margin-top: ${(props) =>
		props?.promoSpacing && !props?.isPromoEligible ? "2.5rem" : "0"};
	@media (min-width: 301px) and (max-width: 545px) {
		margin-top: 0;
		min-width: 252px;
		max-width: 100%;
		// min-width: 220px;
	}
	@media (max-width: 300px) {
		min-width: 190px;
	}
	@media (max-width: 500px) {
		min-height: 450px;
		margin-top: 2.5rem;
	}
`;

const PromoBadge = styled.div`
	height: 2.5rem;
	border-radius: 8px 8px 0px 0px;
	background: #000;
	// width: 100%;
	padding: 0.75rem 1rem;
	margin-bottom: 1rem;
`;

const TileContents = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 0.75rem;
	button:hover {
		background-color: #fff;
		color: black;
	}
	&:last-child {
		ul {
			li {
				&:before {
					margin-top: -2.5px;
				}
			}
		}
	}
`;

const TopSection = styled.div`
	min-height: ${({ minHeight }) => (minHeight ? minHeight : "")};
	margin-bottom: ${({ minHeight }) => (minHeight ? "" : "24px !important;")};
	h4 {
		padding-bottom: 4px;
		line-height: 24px;
	}
	p {
		margin-bottom: 0px;
	}
	@media screen and (max-width: 500px) {
		min-height: ${({ minHeight, height }) =>
			height && minHeight ? "130px" : minHeight ? "115px" : ""};
	}
`;

const PriceLockup = styled.div`
	display: flex;
	flex-direction: row;
	align-items: ${({ name }) => (name ? "baseline" : "")};
	gap: 0.5rem;
	> h1 {
		margin-top: -6px;
	}
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 4px;
  sup {
    font-size: 0.4rem;
    vertical-align: super;
    line-height: 0;
  }
`;

const AppliedToLines = styled.div`
	margin-top: 0.5rem;
	margin-bottom: 3.5rem;
	display: flex;
	justify-content: center;
`;

const PriceTierGrid = styled.div`
	display: grid;
	grid-template-columns: [price] 1.625rem [noOfLines] auto;
	row-gap: 0.25rem;
	column-gap: 1rem;
`;

const PriceTierPrice = styled.div`
	grid-column-start: price;
`;

const PriceTierLines = styled.div`
	grid-column-start: noOfLines;
`;

const DisclaimerItem = styled.div`
	padding-left: 1.2rem;
`;
const ItemWrapper = styled.div`
	min-height: 380px;
`;
export default BusinessPlanCard;
